import { exchangeApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useExchangeAccountQuery = () => {
  return useQuery([QUERIES.EXCHANGE_ACCOUNT], () => exchangeApi.getAccount());
};
